import React from "react"

import Skeleton from "@mui/material/Skeleton"
import { useMediaQuery } from "react-responsive"

import { Row, Col } from "reactstrap"

const Loading = ({ children, loading }) => {
  const isMobile = useMediaQuery({ maxWidth: 576 })

  if (loading) {
    return (
      <Row>
        <Col xs={12} sm={6} className="d-flex flex-column gap-4">
          <Skeleton width={"65%"} />
          <Skeleton width={"60%"} />
          <Skeleton width={"70%"} />
          <Skeleton width={"65%"} />
        </Col>
        {!isMobile && (
          <Col xs={12} sm={6} className="d-flex flex-column gap-4">
            <Skeleton width={"55%"} />
            <Skeleton width={"65%"} />
            <Skeleton width={"55%"} />
            <Skeleton width={"60%"} />
          </Col>
        )}
      </Row>
    )
  }

  return children
}

export default Loading
